var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToBasketDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 10.24H19.6v-.31A3.564 3.564 0 0 0 16 6.4h-.07A3.564 3.564 0 0 0 12.4 10v.24H9.76c-.79.02-1.42.65-1.44 1.44v12.48c.02.79.65 1.42 1.44 1.44h12.48c.79-.02 1.42-.65 1.44-1.44V11.68c-.02-.79-.65-1.42-1.44-1.44Zm-8.4-.24c0-1.19.97-2.16 2.16-2.16 1.19 0 2.16.97 2.16 2.16v.24h-4.32V10Zm8.4 14.16H9.76V11.68h2.64v2.16c0 .4.32.72.72.72s.72-.32.72-.72v-2.16h4.32v2.16c0 .4.32.72.72.72s.72-.32.72-.72v-2.16h2.64v12.48Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.57 22.4v-3.57H12v-.86h3.57V14.4h.86v3.57H20v.86h-3.57v3.57h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.93 22.9h-1.86v-3.57H11.5v-1.86h3.57V13.9h1.86v3.57h3.57v1.86h-3.57v3.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToBasketDesktop);
export default __webpack_public_path__ + "static/media/AddToBasketDesktop.5e366b3d2b493f3fc0fba7fde4073d3e.svg";
export { ForwardRef as ReactComponent };